import {api, http, store} from '@/libs'

store.registerModule('order', {
  namespaced: true,
  state: {
    currentOrder: {},       // 当前正在创建或编辑的订单
    currentAic: {},

    companySelected: null,  // 自费刻章时选择的刻章店

    // current: {
    //   company: {
    //     poi: [],
    //     poiTotalElements: 0,
    //     poiTotalPages: 29,
    //     poiSize: 20,
    //     poiPage: 0
    //   },
    //   material: [],
    //   order: {crpCertType: '111', opCertType: '111', company: {}, seals: []},
    // },
    //
    // sealDetail: {},
    // sealActiveList: [],
    // sealHistoryList: [],

  },

  mutations: {
    // 设置当前操作的工商推送记录
    SET_CURRENT_AIC(state, payload) {
      state.currentAic = payload
    },

    // // 删除当前订单表格中某个订单
    // REMOVE_CURRENT_TABLE_ROW(state, payload) {
    //   state.current.table.content.splice(payload._index, 1)
    // },

    // 初始化当前的状态数据
    SET_INIT_STATE(state) {
      state.companySelected = null
    },

    // 初始化当前订单
    SET_INIT_ORDER(state) {
      store.commit('order/SET_INIT_STATE')
      state.currentOrder = {
        orderType: '0',
        crpCertType: '111',
        opCertType: '111',
        seals: [],
        deliverType: '0',
        opSameWithCrp: true,
      }
    },

    // 设置订单详情
    SET_CURRENT_ORDER(state, payload) {
      state.currentOrder = payload
      state.companySelected = state.currentOrder.company
    },

    // 自费买单, 选择刻章店
    SET_COMPANY_SELECTED(state, payload) {
      state.companySelected = payload
    }

    // // 获取poi
    // QUERY_CURREN_COMPANY_POI(state, payload) {
    //   state.current.company.poi = payload.content
    //   state.current.company.poiTotalElements = payload.totalElements
    //   state.current.company.poiTotalPages = payload.totalPages
    //   state.current.company.poiSize = payload.size
    //   state.current.company.poiPage = payload.number
    // },

    // // queryMaterial
    // SET_ORDER_MATERIAL(state, payload) {
    //   state.current.material = payload
    // },
    //
    // //设置电子公章-当前订单列表
    // SET_SEAL_ACTIVE_LIST(state, payload) {
    //   state.sealActiveList = payload
    // },
    // //设置电子公章-历史订单列表
    // SET_SEAL_HISTORY_LIST(state, payload) {
    //   state.sealHistoryList = payload
    // },
    // //设置电子公章详情
    // SET_SEAL_DETAIL(state, payload) {
    //   Object.assign(state.sealDetail, payload)
    // },
    // //设置电子公章列表的一行
    // SET_ESEAL_LIST_ROW(state, {payload, id}) {
    //   state.sealActiveList.content = util.tableData(state.sealActiveList.content, {payload, id})
    // },
    // //初始化eSeal
    // initSealDetail(state, payload) {
    //   state.sealDetail = {}
    // },

  },

  'actions': {
    // 获取订单详情
    getOrderById(store, params) {
      return http.get(api.gzwCusOrder.order, {params: params}).then(payload => {
        store.commit('SET_CURRENT_ORDER', payload)
        return payload
      })
    },

    // 新增编辑订单
    postSaveOrder(store, params) {
      params = {orderJson: store.state.currentOrder, id: store.state.currentOrder.id}
      return http.post(api.gzwCusOrder.order, params).then(payload => {
        store.commit('SET_CURRENT_ORDER', payload)
        return payload
      })
    },

    // 删除订单
    deleteOrder(store, param) {
      return http.delete(api.gzwCusOrder.order, {params: {id: param.id}})
    },

    // 选择刻章店
    postOrderSubmitCompany(store, params) {
      return http.post(api.sealWebCus.orderSubmitCompany, params).then(payload => {
        store.commit('SET_CURRENT_ORDER', payload)
        return payload
      })
    },

    // 印章新增和编辑
    postOrderSeal(store, param) {
      return http.post(api.gzwCusOrder.orderSeal, param)
    },

    // 删除印章
    deleteOrderSeal(store, param) {
      return http.delete(api.gzwCusOrder.orderSeal, {params: param})
    },

    // // 印章订单-获取章材列表
    // queryMaterial(store, id) {
    //   return http.get(api.gzwCusOrder.queryMaterial, {params: {companyId: id}}).then(payload => store.commit('SET_ORDER_MATERIAL', payload))
    // },
    //
    // // 电子公章列表
    // getSealActiveList(store, param) {
    //   return http.get(api.gzwCusDz.dzSeal, {params: param}).then(payload => store.commit('SET_SEAL_ACTIVE_LIST', payload))
    // },
    //
    // // 新增电子公章
    // addEseal(store, param) {
    //   return http.post(api.gzwCusDz.dzSeal, {dzSealJson: param.dzSealJson}).then(payload => store.commit('SET_SEAL_DETAIL', payload))
    // },
    //
    // // 电子公章详情
    // getSealDetail(store, params) {
    //   return http.get(api.gzwCusDz.dzSeal, {params}).then(payload => store.commit('SET_SEAL_DETAIL', payload))
    // },
    //
    // // 编辑电子公章
    // editEseal(store, param) {
    //   return http.post(api.gzwCusDz.dzSeal, {
    //     id: param.id,
    //     dzSealJson: param.dzSealJson
    //   }).then(payload => store.commit('SET_SEAL_DETAIL', payload))
    // },
    //
    // // 删除电子公章
    // deleteEseal(store, param) {
    //   const id = param.id
    //   return http.delete(api.gzwCusDz.dzSeal, {params: {id: param.id}}).then(payload => store.commit('SET_ESEAL_LIST_ROW', {
    //     payload,
    //     id: id
    //   }))
    // },
  }

})

export default store
